import React from 'react';
import { Link } from 'react-router-dom';
import ScrollReveal from '../common/ScrollReveal';
import kanjiRojo from '../../assets/images/toyo-kanji-rojo.png';
import arbolToyo from '../../assets/images/home-noticias-bg.svg';
import { NOTICIAS } from '../../data/mockNoticias';

function NewsSection() {
  // No necesitamos useState ni useEffect ya que usamos datos estáticos
  const latestNews = NOTICIAS;

  return (
    <section className="py-16 relative bg-brand-dark overflow-hidden">
      {/* Imagen de fondo superior izquierda */}
      <div 
        className="absolute bottom-0 left-0 w-[500px] h-[500px] opacity-70"
        style={{
          backgroundImage: `url(${arbolToyo})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          transform: 'rotate(180deg) scaleY(-1)'
        }}
      />

      {/* Imagen de fondo inferior derecha */}
      <div 
        className="absolute top-0 right-0 w-[500px] h-[500px] opacity-70"
        style={{
          backgroundImage: `url(${arbolToyo})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          transform: 'rotate(0deg)'
        }}
      />

      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center mb-12">
          <h2 className="text-6xl font-morganite text-brand-white tracking-wider">NOTICIAS</h2>
          <img src={kanjiRojo} alt="" className="h-11" />
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          <ScrollReveal>
            <Link to={`/noticias/${latestNews[0].slug}`} className="block group">
              <div className="relative rounded-lg overflow-hidden h-[500px]">
                <img 
                  src={latestNews[0].images[0]}
                  alt={latestNews[0].title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute bottom-0 left-0 right-0 p-6 gradient-overlay">
                  <h3 className="text-4xl font-extrabold font-morganite text-brand-white mb-2">
                    {latestNews[0].title}
                  </h3>
                  <span className="inline-block text-brand-dark font-bold font-helvetica text-sm bg-brand-white px-4 py-1 rounded-lg">
                    VER MÁS
                  </span>
                </div>
              </div>
            </Link>
          </ScrollReveal>

          <div className="flex flex-col gap-6">
            {latestNews.slice(1, 3).map((noticia) => (
              <ScrollReveal key={noticia.id}>
                <Link to={`/noticias/${noticia.slug}`} className="block group">
                  <div className="relative rounded-lg overflow-hidden h-[238px]">
                    <img 
                      src={noticia.images[0]}
                      alt={noticia.title}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    />
                    <div className="absolute bottom-0 left-0 right-0 p-6 gradient-overlay">
                      <h3 className="text-3xl font-extrabold font-morganite text-brand-white mb-2">
                        {noticia.title}
                      </h3>
                      <span className="inline-block text-brand-dark font-bold font-helvetica text-sm bg-brand-white px-4 py-1 rounded-lg">
                        VER MÁS
                      </span>
                    </div>
                  </div>
                </Link>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default NewsSection;